import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SettingsService } from '@app/shared/services/settings/settings.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-delete-account',
  templateUrl: './dialog-delete-account.component.html',
  styleUrls: ['./dialog-delete-account.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('150ms', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('150ms', style({ transform: 'translateX(100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class DialogDeleteAccountComponent implements OnInit {
  account: any;
  inputEmail: string;
  inputMismatch: boolean;
  deleting: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogDeleteAccountComponent>,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.account = this.data.acc;
  }

  cancelClicked() {
    this.dialogRef.close(false);
  }

  okClicked() {
    this.deleting = true;

    if (this.inputEmail === 'DELETE') {
      this.settingsService.deleteAccount(this.account.delete_link).subscribe((res) => {
        this.deleting = false;
        this.dialogRef.close(true);
      });
    } else {
      this.deleting = false;
      this.inputMismatch = true;
      setTimeout(() => {
        this.inputMismatch = false;
      }, 2000);
    }
  }
}
